import { render, staticRenderFns } from "./BrandingCard.vue?vue&type=template&id=61a8f8c5&"
import script from "./BrandingCard.vue?vue&type=script&lang=ts&"
export * from "./BrandingCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandingCard.vue?vue&type=style&index=0&id=61a8f8c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports